import {Instant} from "@js-joda/core";

// following data gets generated by /infra/applyBuildInfo.js
export const buildInfo = {
	buildMoment: Instant.parse("2026-11-04T20:31:31.622Z"),
	version: "1.3.1",
};
